import { Box, Group, Text } from "@mantine/core";
import { useAppSelector } from "../app/hooks";
import { articleColoringApi } from "../SettingPage/articleColoringApi";
import { usePostMultiplacerArticlesByCompCodesQuery } from "../../openapi";
import { selectActiveArticleColoring, selectArticleQueryArgs } from "./articleColoringSelectors";

export const ArticleColoring = () => {
  const projectNo = useAppSelector(state => state.design.projectNo);
  articleColoringApi.useGetMultiplacerProjectArticleColoringQuery({ projectNo }, { skip: !projectNo });
  const args = useAppSelector(selectArticleQueryArgs);
  const { isFetching, isError, currentData } = usePostMultiplacerArticlesByCompCodesQuery(
    args ?? { body: { projectNo, compCodes: [] } }, { skip: args == null },
  );
  const filter = useAppSelector(selectActiveArticleColoring);
  if (!filter) return null;
  return <Box px="sm" py={6} style={{ borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
    <Group gap="sm">
      <Text size="xs" fw={600}>{filter.label}</Text>
      {filter.values.map(entry => <Group key={entry.value} gap={6}>
        <Box w={10} h={10} bg={entry.color} style={{ borderRadius: 3 }} />
        <Text size="xs">{entry.label || entry.value}</Text>
      </Group>)}
      {filter.fallbackColor && <Group gap={6}>
        <Box w={10} h={10} bg={filter.fallbackColor} style={{ borderRadius: 3 }} />
        <Text size="xs">Ingen treff</Text>
      </Group>}
      {args && <Text size="xs" c={isError ? "red" : "dimmed"}>
        {isError ? "Kunne ikke hente artikkeldata" : isFetching ? "Henter artikkeldata…"
          : currentData?.runId === null ? "Ingen komplett artikkelimport tilgjengelig" : null}
      </Text>}
    </Group>
  </Box>;
};
